import config from './config';
export const login = () => {
    const { tenantId, clientId, redirectUri, authority, scope } = config;
    const params = new URLSearchParams({
        client_id: clientId,
        response_type: 'token',
        redirect_uri: redirectUri,
        // response_mode: 'fragment',
        scope: scope,
    });
    window.location.href = `${authority}/${tenantId}/oauth2/v2.0/authorize?${params.toString()}`;
};

export const logout = () => {
    const { tenantId, redirectUriLogin, authority } = config;
    const params = new URLSearchParams({
        post_logout_redirect_uri: redirectUriLogin,
    });
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = `${authority}/${tenantId}/oauth2/v2.0/logout?${params.toString()}`;
};

export const getTokenFromUrl = () => {
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    return params.get('access_token');
}; 